import styled from 'styled-components';
import { StyledBox } from '@tryhackme/thm-ui-components';

import { StyledLoading } from 'src/common/components';

export const StyledCertificatesSection = styled.section`
  padding: 2.4rem 0 3.6rem;
`;

export const StyledFiltersWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 22.2rem;
  margin-bottom: 3.2rem;
`;

export const StyledNoCertificates = styled(StyledBox)`
  display: grid;
  place-items: center;
  padding: 6.2rem 2rem;
  width: 100%;

  svg {
    font-size: 6.8rem;
    width: auto;
    height: 6.7rem;
    path {
      fill: ${({ theme }) => theme.colors.overlay};
    }
  }

  p {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    color: ${({ theme }) => theme.colors.text.main};
    margin: 1.6rem 0 0.8rem;
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }
  a {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }
`;

export const StyledLoadingCard = styled(StyledLoading)`
  margin-bottom: 2.4rem;
  animation-duration: 1s;
`;
